"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PushViewButton = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("../../icon"));
var _chevronLeft = _interopRequireDefault(require("../../../icons/chevron-left"));
var _chevronRight = _interopRequireDefault(require("../../../icons/chevron-right"));
require("./hamburger-nav.css");
var _excluded = ["active", "subNavItems", "tagName", "href", "direction", "children", "pushViewButtonLabels", "addRule"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-unused-vars */
var PushViewButton = exports.PushViewButton = function PushViewButton(_ref) {
  var active = _ref.active,
    subNavItems = _ref.subNavItems,
    tagName = _ref.tagName,
    href = _ref.href,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'right' : _ref$direction,
    children = _ref.children,
    _ref$pushViewButtonLa = _ref.pushViewButtonLabels,
    pushViewButtonLabels = _ref$pushViewButtonLa === void 0 ? {} : _ref$pushViewButtonLa,
    _ref$addRule = _ref.addRule,
    addRule = _ref$addRule === void 0 ? false : _ref$addRule,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isRightDirection = direction === 'right';
  var isLeftDirection = direction === 'left';
  var _pushViewButtonLabels = pushViewButtonLabels.pushViewButtonLabelLeft,
    pushViewButtonLabelLeft = _pushViewButtonLabels === void 0 ? '' : _pushViewButtonLabels,
    _pushViewButtonLabels2 = pushViewButtonLabels.pushViewButtonLabelRightFormatter,
    pushViewButtonLabelRightFormatter = _pushViewButtonLabels2 === void 0 ? function () {
      return '';
    } : _pushViewButtonLabels2;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])({
      'sb-hamburgerNav-navItem-rule': addRule
    })
  }, /*#__PURE__*/_react["default"].createElement("button", _extends({
    "aria-label": isRightDirection ? pushViewButtonLabelRightFormatter(children) : pushViewButtonLabelLeft,
    className: (0, _classnames["default"])('sb-hamburgerNavItem text-noUnderline text-md py3 px5', {
      'sb-hamburgerNav-pushViewButton-right': isRightDirection,
      'bg-neutralCool text-center size12of12 sb-hamburgerNav-pushViewButton-left py3': isLeftDirection
    }),
    id: "hamburger-nav-push-view-btn-".concat(children, "-").concat(direction)
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: (0, _classnames["default"])({
      'sb-hamburgerNav-pushViewButton-left-arrow': isLeftDirection
    }),
    path: isRightDirection ? _chevronRight["default"] : _chevronLeft["default"]
  }), /*#__PURE__*/_react["default"].createElement("span", null, children)));
};
PushViewButton.propTypes = process.env.NODE_ENV !== "production" ? {
  direction: _propTypes["default"].oneOf(['left', 'right']),
  children: _propTypes["default"].string
} : {};
var _default = exports["default"] = PushViewButton;